export const regionsAndCommunes = [
    {
    "label": "Arica y Parinacota",
    "romanNumber": "XV",
    "number": "15",
    "value": "arica",
    "communes": [
        { "label": "Arica"        , "value": "arica"         },
        { "label": "Camarones"    , "value": "camarones"     },
        { "label": "General Lagos", "value": "general_lagos" },
        { "label": "Putre"        , "value": "putre"         }
    ]
    },
    {
    "label": "Tarapacá",
    "romanNumber": "I",
    "number": "1",
    "value": "tarapaca",
    "communes": [
        { "label": "Alto Hospicio", "value": "alto_hospicio" },
        { "label": "Camiña"       , "value": "camina"        },
        { "label": "Colchane"     , "value": "colchane"      },
        { "label": "Huara"        , "value": "huara"         },
        { "label": "Iquique"      , "value": "iquique"       },
        { "label": "Pica"         , "value": "pica"          },
        { "label": "Pozo Almonte" , "value": "pozo_almonte"  }
    ]
    },
    {
    "label": "Antofagasta",
    "romanNumber": "II",
    "number": "2",
    "value": "antofagasta",
    "communes": [
        { "label": "Antofagasta"         , "value": "antofagasta"          },
        { "label": "Calama"              , "value": "calama"               },
        { "label": "María Elena"         , "value": "maria_elena"          },
        { "label": "Mejillones"          , "value": "mejillones"           },
        { "label": "Ollagüe"             , "value": "ollague"              },
        { "label": "San Pedro de Atacama", "value": "san_pedro_de_atacama" },
        { "label": "Sierra Gorda"        , "value": "sierra_gorda"         },
        { "label": "Taltal"              , "value": "taltal"               },
        { "label": "Tocopilla"           , "value": "tocopilla"            }
    ]
    },
    {
    "label": "Atacama",
    "romanNumber": "III",
    "number": "3",
    "value": "atacama",
    "communes": [
        { "label": "Alto del Carmen" , "value": "alto_del_carmen"  },
        { "label": "Caldera"         , "value": "caldera"          },
        { "label": "Chañaral"        , "value": "chanaral"         },
        { "label": "Copiapó"         , "value": "copiapo"          },
        { "label": "Diego de Almagro", "value": "diego_de_almagro" },
        { "label": "Freirina"        , "value": "freirina"         },
        { "label": "Huasco"          , "value": "huasco"           },
        { "label": "Tierra Amarilla" , "value": "tierra_amarilla"  },
        { "label": "Vallenar"        , "value": "vallenar"         }
    ]
    },
    {
    "label": "Coquimbo",
    "romanNumber": "IV",
    "number": "4",
    "value": "coquimbo",
    "communes": [
        { "label": "Andacollo"   , "value": "andacollo"    },
        { "label": "Canela"      , "value": "canela"       },
        { "label": "Combarbalá"  , "value": "combarbala"   },
        { "label": "Coquimbo"    , "value": "coquimbo"     },
        { "label": "Illapel"     , "value": "illapel"      },
        { "label": "La Higuera"  , "value": "la_higuera"   },
        { "label": "La Serena"   , "value": "la_serena"    },
        { "label": "Los Vilos"   , "value": "los_vilos"    },
        { "label": "Monte Patria", "value": "monte_patria" },
        { "label": "Ovalle"      , "value": "ovalle"       },
        { "label": "Paiguano"    , "value": "paiguano"     },
        { "label": "Punitaqui"   , "value": "punitaqui"    },
        { "label": "Río Hurtado" , "value": "rio_hurtado"  },
        { "label": "Salamanca"   , "value": "salamanca"    },
        { "label": "Vicuña"      , "value": "vicuna"       }
    ]
    },
    {
    "label": "Valparaíso",
    "romanNumber": "V",
    "number": "5",
    "value": "valparaiso",
    "communes": [
        { "label": "Algarrobo"     , "value": "algarrobo"      },
        { "label": "Cabildo"       , "value": "cabildo"        },
        { "label": "Calera"        , "value": "calera"         },
        { "label": "Calle Larga"   , "value": "calle_larga"    },
        { "label": "Cartagena"     , "value": "cartagena"      },
        { "label": "Casablanca"    , "value": "casablanca"     },
        { "label": "Catemu"        , "value": "catemu"         },
        { "label": "Concón"        , "value": "concon"         },
        { "label": "El Quisco"     , "value": "el_quisco"      },
        { "label": "El Tabo"       , "value": "el_tabo"        },
        { "label": "Hijuelas"      , "value": "hijuelas"       },
        { "label": "Isla de Pascua", "value": "isla_de_pascua" },
        { "label": "Juan Fernández", "value": "juan_fernandez" },
        { "label": "La Cruz"       , "value": "la_cruz"        },
        { "label": "La Ligua"      , "value": "la_ligua"       },
        { "label": "Limache"       , "value": "limache"        },
        { "label": "Llaillay"      , "value": "llaillay"       },
        { "label": "Los Andes"     , "value": "los_andes"      },
        { "label": "Nogales"       , "value": "nogales"        },
        { "label": "Olmué"         , "value": "olmue"          },
        { "label": "Panquehue"     , "value": "panquehue"      },
        { "label": "Papudo"        , "value": "papudo"         },
        { "label": "Petorca"       , "value": "petorca"        },
        { "label": "Puchuncaví"    , "value": "puchuncavi"     },
        { "label": "Putaendo"      , "value": "putaendo"       },
        { "label": "Quillota"      , "value": "quillota"       },
        { "label": "Quilpué"       , "value": "quilpue"        },
        { "label": "Quintero"      , "value": "quintero"       },
        { "label": "Rinconada"     , "value": "rinconada"      },
        { "label": "San Antonio"   , "value": "san_antonio"    },
        { "label": "San Esteban"   , "value": "san_esteban"    },
        { "label": "San Felipe"    , "value": "san_felipe"     },
        { "label": "Santa María"   , "value": "santa_maria"    },
        { "label": "Santo Domingo" , "value": "santo_domingo"  },
        { "label": "Valparaíso"    , "value": "valparaiso"     },
        { "label": "Villa Alemana" , "value": "villa_alemana"  },
        { "label": "Viña del Mar"  , "value": "vina_del_mar"   },
        { "label": "Zapallar"      , "value": "zapallar"       }
    ]
    },
    {
    "label": "Metropolitana de Santiago",
    "romanNumber": "XIII",
    "number": "13",
    "value": "metropolitana",
    "communes": [
        { "label": "Alhué"              , "value": "alhue"               },
        { "label": "Buin"               , "value": "buin"                },
        { "label": "Calera de Tango"    , "value": "calera_de_tango"     },
        { "label": "Cerrillos"          , "value": "cerrillos"           },
        { "label": "Cerro Navia"        , "value": "cerro_navia"         },
        { "label": "Colina"             , "value": "colina"              },
        { "label": "Conchalí"           , "value": "conchali"            },
        { "label": "Curacaví"           , "value": "curacavi"            },
        { "label": "El Bosque"          , "value": "el_bosque"           },
        { "label": "El Monte"           , "value": "el_monte"            },
        { "label": "Estación Central"   , "value": "estacion_central"    },
        { "label": "Huechuraba"         , "value": "huechuraba"          },
        { "label": "Independencia"      , "value": "independencia"       },
        { "label": "Isla de Maipo"      , "value": "isla_de_maipo"       },
        { "label": "La Cisterna"        , "value": "la_cisterna"         },
        { "label": "La Florida"         , "value": "la_florida"          },
        { "label": "La Granja"          , "value": "la_granja"           },
        { "label": "La Pintana"         , "value": "la_pintana"          },
        { "label": "La Reina"           , "value": "la_reina"            },
        { "label": "Lampa"              , "value": "lampa"               },
        { "label": "Las Condes"         , "value": "las_condes"          },
        { "label": "Lo Barnechea"       , "value": "lo_barnechea"        },
        { "label": "Lo Espejo"          , "value": "lo_espejo"           },
        { "label": "Lo Prado"           , "value": "lo_prado"            },
        { "label": "Macul"              , "value": "macul"               },
        { "label": "Maipú"              , "value": "maipu"               },
        { "label": "María Pinto"        , "value": "maria_pinto"         },
        { "label": "Melipilla"          , "value": "melipilla"           },
        { "label": "Ñuñoa"              , "value": "nunoa"               },
        { "label": "Padre Hurtado"      , "value": "padre_hurtado"       },
        { "label": "Paine"              , "value": "paine"               },
        { "label": "Pedro Aguirre Cerda", "value": "pedro_aguirre_cerda" },
        { "label": "Peñaflor"           , "value": "penaflor"            },
        { "label": "Peñalolén"          , "value": "penalolen"           },
        { "label": "Pirque"             , "value": "pirque"              },
        { "label": "Providencia"        , "value": "providencia"         },
        { "label": "Pudahuel"           , "value": "pudahuel"            },
        { "label": "Puente Alto"        , "value": "puente_alto"         },
        { "label": "Quilicura"          , "value": "quilicura"           },
        { "label": "Quinta Normal"      , "value": "quinta_normal"       },
        { "label": "Recoleta"           , "value": "recoleta"            },
        { "label": "Renca"              , "value": "renca"               },
        { "label": "San Bernardo"       , "value": "san_bernardo"        },
        { "label": "San Joaquín"        , "value": "san_joaquin"         },
        { "label": "San José de Maipo"  , "value": "san_jose_de_maipo"   },
        { "label": "San Miguel"         , "value": "san_miguel"          },
        { "label": "San Pedro"          , "value": "san_pedro"           },
        { "label": "San Ramón"          , "value": "san_ramon"           },
        { "label": "Santiago"           , "value": "santiago"            },
        { "label": "Talagante"          , "value": "talagante"           },
        { "label": "Tiltil"             , "value": "tiltil"              },
        { "label": "Vitacura"           , "value": "vitacura"            }
    ]
    },
    {
    "label": "Libertador Gral. Bernardo O’Higgins",
    "romanNumber": "VI",
    "number": "6",
    "value": "ohiggins",
    "communes": [
        { "label": "Chimbarongo"      , "value": "chimbarongo"       },
        { "label": "Chépica"          , "value": "chepica"           },
        { "label": "Codegua"          , "value": "codegua"           },
        { "label": "Coinco"           , "value": "coinco"            },
        { "label": "Coltauco"         , "value": "coltauco"          },
        { "label": "Doñihue"          , "value": "donihue"           },
        { "label": "Graneros"         , "value": "graneros"          },
        { "label": "La Estrella"      , "value": "la_estrella"       },
        { "label": "Las Cabras"       , "value": "las_cabras"        },
        { "label": "Litueche"         , "value": "litueche"          },
        { "label": "Lolol"            , "value": "lolol"             },
        { "label": "Machalí"          , "value": "machali"           },
        { "label": "Malloa"           , "value": "malloa"            },
        { "label": "Marchihue"        , "value": "marchihue"         },
        { "label": "Nancagua"         , "value": "nancagua"          },
        { "label": "Navidad"          , "value": "navidad"           },
        { "label": "Olivar"           , "value": "olivar"            },
        { "label": "Mostazal"         , "value": "mostazal"          },
        { "label": "Palmilla"         , "value": "palmilla"          },
        { "label": "Paredones"        , "value": "paredones"         },
        { "label": "Peralillo"        , "value": "peralillo"         },
        { "label": "Peumo"            , "value": "peumo"             },
        { "label": "Pichidegua"       , "value": "pichidegua"        },
        { "label": "Pichilemu"        , "value": "pichilemu"         },
        { "label": "Placilla"         , "value": "placilla"          },
        { "label": "Pumanque"         , "value": "pumanque"          },
        { "label": "Quinta de Tilcoco", "value": "quinta_de_tilcoco" },
        { "label": "Rancagua"         , "value": "rancagua"          },
        { "label": "Rengo"            , "value": "rengo"             },
        { "label": "Requínoa"         , "value": "requinoa"          },
        { "label": "San Fernando"     , "value": "san_fernando"      },
        { "label": "San Vicente"      , "value": "san_vicente"       },
        { "label": "Santa Cruz"       , "value": "santa_cruz"        }
    ]
    },
    {
    "label": "Maule",
    "romanNumber": "VII",
    "number": "7",
    "value": "maule",
    "communes": [
        { "label": "Cauquenes"               , "value": "cauquenes"                },
        { "label": "Chanco"                  , "value": "chanco"                   },
        { "label": "Colbún"                  , "value": "colbun"                   },
        { "label": "Constitución"            , "value": "constitucion"             },
        { "label": "Curepto"                 , "value": "curepto"                  },
        { "label": "Curicó"                  , "value": "curico"                   },
        { "label": "Empedrado"               , "value": "empedrado"                },
        { "label": "Hualañé"                 , "value": "hualane"                  },
        { "label": "Licantén"                , "value": "licanten"                 },
        { "label": "Linares"                 , "value": "linares"                  },
        { "label": "Longaví"                 , "value": "longavi"                  },
        { "label": "Maule"                   , "value": "maule"                    },
        { "label": "Molina"                  , "value": "molina"                   },
        { "label": "Parral"                  , "value": "parral"                   },
        { "label": "Pelarco"                 , "value": "pelarco"                  },
        { "label": "Pelluhue"                , "value": "pelluhue"                 },
        { "label": "Pencahue"                , "value": "pencahue"                 },
        { "label": "Rauco"                   , "value": "rauco"                    },
        { "label": "Retiro"                  , "value": "retiro"                   },
        { "label": "Romeral"                 , "value": "romeral"                  },
        { "label": "Río Claro"               , "value": "rio_claro"                },
        { "label": "Sagrada Familia"         , "value": "sagrada_familia"          },
        { "label": "San Clemente"            , "value": "san_clemente"             },
        { "label": "San Javier de Loncomilla", "value": "san_javier_de_loncomilla" },
        { "label": "San Rafael"              , "value": "san_rafael"               },
        { "label": "Talca"                   , "value": "talca"                    },
        { "label": "Teno"                    , "value": "teno"                     },
        { "label": "Vichuquén"               , "value": "vichuquen"                },
        { "label": "Villa Alegre"            , "value": "villa_alegre"             },
        { "label": "Yerbas Buenas"           , "value": "yerbas_buenas"            }
    ]
    },
    {
    "label": "Ñuble",
    "romanNumber": "XVI",
    "number": "16",
    "value": "nuble",
    "communes": [
        { "label": "Bulnes"       , "value": "bulnes"        },
        { "label": "Chillán Viejo", "value": "chillan_viejo" },
        { "label": "Chillán"      , "value": "chillan"       },
        { "label": "Cobquecura"   , "value": "cobquecura"    },
        { "label": "Coelemu"      , "value": "coelemu"       },
        { "label": "Coihueco"     , "value": "coihueco"      },
        { "label": "El Carmen"    , "value": "el_carmen"     },
        { "label": "Ninhue"       , "value": "ninhue"        },
        { "label": "Ñiquén"       , "value": "niquen"        },
        { "label": "Pemuco"       , "value": "pemuco"        },
        { "label": "Pinto"        , "value": "pinto"         },
        { "label": "Portezuelo"   , "value": "portezuelo"    },
        { "label": "Quillón"      , "value": "quillon"       },
        { "label": "Quirihue"     , "value": "quirihue"      },
        { "label": "Ránquil"      , "value": "ranquil"       },
        { "label": "San Carlos"   , "value": "san_carlos"    },
        { "label": "San Fabián"   , "value": "san_fabian"    },
        { "label": "San Ignacio"  , "value": "san_ignacio"   },
        { "label": "San Nicolás"  , "value": "san_nicolas"   },
        { "label": "Treguaco"     , "value": "treguaco"      },
        { "label": "Yungay"       , "value": "yungay"        }
    ]
    },
    {
    "label": "Biobío",
    "romanNumber": "VIII",
    "number": "8",
    "value": "biobio",
    "communes": [
        { "label": "Alto Biobío"        , "value": "alto_biobio"         },
        { "label": "Antuco"             , "value": "antuco"              },
        { "label": "Arauco"             , "value": "arauco"              },
        { "label": "Cabrero"            , "value": "cabrero"             },
        { "label": "Cañete"             , "value": "canete"              },
        { "label": "Chiguayante"        , "value": "chiguayante"         },
        { "label": "Concepción"         , "value": "concepcion"          },
        { "label": "Contulmo"           , "value": "contulmo"            },
        { "label": "Coronel"            , "value": "coronel"             },
        { "label": "Curanilahue"        , "value": "curanilahue"         },
        { "label": "Florida"            , "value": "florida"             },
        { "label": "Hualpén"            , "value": "hualpen"             },
        { "label": "Hualqui"            , "value": "hualqui"             },
        { "label": "Laja"               , "value": "laja"                },
        { "label": "Lebu"               , "value": "lebu"                },
        { "label": "Los Álamos"         , "value": "los_alamos"          },
        { "label": "Los Ángeles"        , "value": "los_angeles"         },
        { "label": "Lota"               , "value": "lota"                },
        { "label": "Mulchén"            , "value": "mulchen"             },
        { "label": "Nacimiento"         , "value": "nacimiento"          },
        { "label": "Negrete"            , "value": "negrete"             },
        { "label": "Penco"              , "value": "penco"               },
        { "label": "Quilaco"            , "value": "quilaco"             },
        { "label": "Quilleco"           , "value": "quilleco"            },
        { "label": "San Pedro de la Paz", "value": "san_pedro_de_la_paz" },
        { "label": "San Rosendo"        , "value": "san_rosendo"         },
        { "label": "Santa Bárbara"      , "value": "santa_barbara"       },
        { "label": "Santa Juana"        , "value": "santa_juana"         },
        { "label": "Talcahuano"         , "value": "talcahuano"          },
        { "label": "Tirúa"              , "value": "tirua"               },
        { "label": "Tomé"               , "value": "tome"                },
        { "label": "Tucapel"            , "value": "tucapel"             },
        { "label": "Yumbel"             , "value": "yumbel"              }
    ]
    },
    {
    "label": "Araucanía",
    "romanNumber": "IX",
    "number": "9",
    "value": "araucania",
    "communes": [
        { "label": "Angol"          , "value": "angol"           },
        { "label": "Carahue"        , "value": "carahue"         },
        { "label": "Cholchol"       , "value": "cholchol"        },
        { "label": "Collipulli"     , "value": "collipulli"      },
        { "label": "Cunco"          , "value": "cunco"           },
        { "label": "Curacautín"     , "value": "curacautin"      },
        { "label": "Curarrehue"     , "value": "curarrehue"      },
        { "label": "Ercilla"        , "value": "ercilla"         },
        { "label": "Freire"         , "value": "freire"          },
        { "label": "Galvarino"      , "value": "galvarino"       },
        { "label": "Gorbea"         , "value": "gorbea"          },
        { "label": "Lautaro"        , "value": "lautaro"         },
        { "label": "Loncoche"       , "value": "loncoche"        },
        { "label": "Lonquimay"      , "value": "lonquimay"       },
        { "label": "Los Sauces"     , "value": "los_sauces"      },
        { "label": "Lumaco"         , "value": "lumaco"          },
        { "label": "Melipeuco"      , "value": "melipeuco"       },
        { "label": "Nueva Imperial" , "value": "nueva_imperial"  },
        { "label": "Padre las Casas", "value": "padre_las_casas" },
        { "label": "Perquenco"      , "value": "perquenco"       },
        { "label": "Pitrufquén"     , "value": "pitrufquen"      },
        { "label": "Pucón"          , "value": "pucon"           },
        { "label": "Purén"          , "value": "puren"           },
        { "label": "Renaico"        , "value": "renaico"         },
        { "label": "Saavedra"       , "value": "saavedra"        },
        { "label": "Temuco"         , "value": "temuco"          },
        { "label": "Teodoro Schmidt", "value": "teodoro_schmidt" },
        { "label": "Toltén"         , "value": "tolten"          },
        { "label": "Traiguén"       , "value": "traiguen"        },
        { "label": "Victoria"       , "value": "victoria"        },
        { "label": "Vilcún"         , "value": "vilcun"          },
        { "label": "Villarrica"     , "value": "villarrica"      }
    ]
    },
    {
    "label": "Los Ríos",
    "romanNumber": "XIV",
    "number": "14",
    "value": "rios",
    "communes": [
        { "label": "Corral"     , "value": "corral"      },
        { "label": "Futrono"    , "value": "futrono"     },
        { "label": "La Unión"   , "value": "la_union"    },
        { "label": "Lago Ranco" , "value": "lago_ranco"  },
        { "label": "Lanco"      , "value": "lanco"       },
        { "label": "Los Lagos"  , "value": "los_lagos"   },
        { "label": "Mariquina"  , "value": "mariquina"   },
        { "label": "Máfil"      , "value": "mafil"       },
        { "label": "Paillaco"   , "value": "paillaco"    },
        { "label": "Panguipulli", "value": "panguipulli" },
        { "label": "Río Bueno"  , "value": "rio_bueno"   },
        { "label": "Valdivia"   , "value": "valdivia"    }
    ]
    },
    {
    "label": "Los Lagos",
    "romanNumber": "X",
    "number": "10",
    "value": "lagos",
    "communes": [
        { "label": "Ancud"               , "value": "ancud"                },
        { "label": "Calbuco"             , "value": "calbuco"              },
        { "label": "Castro"              , "value": "castro"               },
        { "label": "Chaitén"             , "value": "chaiten"              },
        { "label": "Chonchi"             , "value": "chonchi"              },
        { "label": "Cochamó"             , "value": "cochamo"              },
        { "label": "Curaco de Vélez"     , "value": "curaco_de_velez"      },
        { "label": "Dalcahue"            , "value": "dalcahue"             },
        { "label": "Fresia"              , "value": "fresia"               },
        { "label": "Frutillar"           , "value": "frutillar"            },
        { "label": "Futaleufú"           , "value": "futaleufu"            },
        { "label": "Hualaihué"           , "value": "hualaihue"            },
        { "label": "Llanquihue"          , "value": "llanquihue"           },
        { "label": "Los Muermos"         , "value": "los_muermos"          },
        { "label": "Maullín"             , "value": "maullin"              },
        { "label": "Osorno"              , "value": "osorno"               },
        { "label": "Palena"              , "value": "palena"               },
        { "label": "Puerto Montt"        , "value": "puerto_montt"         },
        { "label": "Puerto Octay"        , "value": "puerto_octay"         },
        { "label": "Puerto Varas"        , "value": "puerto_varas"         },
        { "label": "Puqueldón"           , "value": "puqueldon"            },
        { "label": "Purranque"           , "value": "purranque"            },
        { "label": "Puyehue"             , "value": "puyehue"              },
        { "label": "Queilén"             , "value": "queilen"              },
        { "label": "Quellón"             , "value": "quellon"              },
        { "label": "Quemchi"             , "value": "quemchi"              },
        { "label": "Quinchao"            , "value": "quinchao"             },
        { "label": "Río Negro"           , "value": "rio_negro"            },
        { "label": "San Juan de la Costa", "value": "san_juan_de_la_costa" },
        { "label": "San Pablo"           , "value": "san_pablo"            }
    ]
    },
    {
    "label": "Aisén del Gral. Carlos Ibáñez del Campo",
    "romanNumber": "XI",
    "number": "11",
    "value": "aisen",
    "communes": [
        { "label": "Aysén"      , "value": "aysen"       },
        { "label": "Chile Chico", "value": "chile_chico" },
        { "label": "Cisnes"     , "value": "cisnes"      },
        { "label": "Cochrane"   , "value": "cochrane"    },
        { "label": "Coyhaique"  , "value": "coyhaique"   },
        { "label": "Guaitecas"  , "value": "guaitecas"   },
        { "label": "Lago Verde" , "value": "lago_verde"  },
        { "label": "O’Higgins"  , "value": "ohiggins"   },
        { "label": "Río Ibáñez" , "value": "rio_ibanez"  },
        { "label": "Tortel"     , "value": "tortel"      }
    ]
    },
    {
    "label": "Magallanes y de la Antártica Chilena",
    "romanNumber": "XII",
    "number": "12",
    "value": "magallanes",
    "communes": [
        { "label": "Antártica"       , "value": "antartica"        },
        { "label": "Cabo de Hornos"  , "value": "cabo_de_hornos"   },
        { "label": "Laguna Blanca"   , "value": "laguna_blanca"    },
        { "label": "Natales"         , "value": "natales"          },
        { "label": "Porvenir"        , "value": "porvenir"         },
        { "label": "Primavera"       , "value": "primavera"        },
        { "label": "Punta Arenas"    , "value": "punta_arenas"     },
        { "label": "Río Verde"       , "value": "rio_verde"        },
        { "label": "San Gregorio"    , "value": "san_gregorio"     },
        { "label": "Timaukel"        , "value": "timaukel"         },
        { "label": "Torres del Paine", "value": "torres_del_paine" }
    ]
    }
]